<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.mailSmsSettings') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <i class="fa fa-cogs"></i>
          <span>{{ $ml.get('shared.settings') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.mailSmsSettings') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-12 text-center">
          <a href="#mail-ayarlari" data-toggle="tab" :title="$ml.get('mailSmsSettings.mailSettings')"
            class="btn btn-app">
            <i class="fa fa-envelope"></i>
            <span>{{ $ml.get('mailSmsSettings.mailSettings') }}</span>
          </a>
          <a v-show="modules.sms" href="#sms-ayarlari" data-toggle="tab" :title="$ml.get('mailSmsSettings.smsSettings')"
            class="btn btn-app">
            <i class="fa fa-commenting"></i>
            <span>{{ $ml.get('mailSmsSettings.smsSettings') }}</span>
          </a>
        </div>
        <div class="col-sm-12">
          <div class="tab-content">
            <div class="tab-pane active" id="mail-ayarlari">
              <div class="row">
                <div class="col-sm-4">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h3 class="box-title">
                        <span>
                          <i class="fa fa-clock-o"></i>
                          {{ $ml.get('mailSmsSettings.automaticMailList') }}
                        </span>
                      </h3>
                      <div class="box-tools pull-right"></div>
                      <div class="box-body">
                        <div v-show="mailList.length > 0" class="table-responsive no-padding" :style="windowHeightSize">
                          <table class="table table-hover">
                            <tbody>
                              <tr v-for="mail in mailList" :key="mail.id">
                                <td>{{ mail.name }}</td>
                                <td class="pull-right">
                                  <button type="button" @click="getMail(mail)" class="btn btn-primary btn-sm">
                                    <i class="fa fa-search"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-show="mailList.length == 0" class="callout callout-info">
                          <i class="fa fa-info-circle"></i>
                          {{ $ml.get('alerts.recordNotFound') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h3 class="box-title">
                        <span>
                          <i class="fa fa-file-text"></i>
                          {{ $ml.get('mailSmsSettings.mailDetails') }}
                        </span>
                      </h3>
                      <div class="box-tools pull-right">
                        <button @click="newMail()" class="btn  btn-sm btn-warning">
                          <i class="fa fa-plus"></i> {{ $ml.get('mailSmsSettings.newMailDefinition') }}
                        </button>
                      </div>
                    </div>
                    <div class="box-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>
                              <i class="fa fa-pencil"></i> {{ $ml.get('mailSmsSettings.mailDefinitionName') }}
                            </label>
                            <input type="text" class="form-control" v-model="selectedMail.name" />
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>
                              <i class="fa fa-bookmark"></i> {{ $ml.get('mailSmsSettings.mailHeader') }}
                            </label>
                            <input type="text" class="form-control" v-model="selectedMail.header" />
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="form-group">
                            <label>
                              <i class="fa fa-edit"></i> {{ $ml.get('mailSmsSettings.mailContent') }}
                            </label>
                            <textarea type="text" class="form-control" v-model="selectedMail.content" />
                          </div>
                        </div>
                        <div class="col-sm-3">
                          <div class="form-group">
                            <label>
                              <i class="fa fa-calendar"></i> {{ $ml.get('mailSmsSettings.mailSendingTime') }}
                            </label>
                            <table class="table table-hover">
                              <tbody>
                                <tr v-for="day in dayList" :key="day.value" :value="day.value">
                                  <td class="checkbox">
                                    <label style="margin-left:30px">
                                      <input type="checkbox" name="check" :checked="day.check"
                                        @change="day.check == true ? day.check = false : day.check = true" />
                                      {{ day.name }}
                                    </label>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="col-sm-3">
                          <div class="form-group">
                            <label>
                              <i class="fa fa-clock-o"></i> {{ $ml.get('mailSmsSettings.time') }}
                            </label>
                            <input v-model="selectedMail.time" type="time" class="form-control" />
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>
                              <i class="fa fa-file-text"></i> {{ $ml.get('mailSmsSettings.reportsToSubmit') }}
                            </label>
                            <table class="table table-hover">
                              <tbody>
                                <tr v-for="report in reportList" :key="report.id" :value="report.id">
                                  <td class="checkbox">
                                    <label style="margin-left:30px">
                                      <input type="checkbox" name="check" :checked="report.checked"
                                        @change="report.checked == true ? report.checked = false : report.checked = true" />
                                      {{ report.name }}
                                    </label>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <button :disabled="selectedMail.filterType != 0" class="btn btn-danger" data-toggle="modal"
                            data-target="#modal-filtre" style="width:100%;margin-bottom:10px;">
                            <i class="fa fa-filter"></i> {{ $ml.get('mailSmsSettings.filterGroup') }}
                          </button>
                          <hr />
                          <div class="form-group">
                            <label>
                              <i class="fa fa-envelope"></i> {{ $ml.get('mailSmsSettings.emailAddressesToSend') }}
                            </label>
                            <input @keyup.enter="addEmail()" :disabled="selectedMail.filterType != 0"
                              v-model="selectedEmail" type="text" :placeholder="$ml.get('mailSmsSettings.enterAEmail')"
                              class="form-control" style="margin-bottom:7px;" autocomplete="false" />
                            <button :disabled="selectedMail.filterType != 0" @click="addEmail()" type="button"
                              class="btn btn-primary " style="width:100%;margin-bottom:10px;">
                              <i class="fa fa-plus"></i> {{ $ml.get('general.add') }}
                            </button>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <table class="table table-hover">
                            <tbody>
                              <tr v-for="(email, index) in emailList" :key="index">
                                <td>
                                  <label>
                                    {{ email }}
                                  </label>
                                </td>
                                <td style="cursor:pointer;"><a :disabled="selectedMail.filterType != 0"
                                    @click="removeEmail(index)" class="text-danger">
                                    <i class="fa fa-remove"></i> {{ $ml.get('general.remove') }}
                                  </a></td>
                              </tr>
                              <tr>
                                <td colspan="2" v-show="emailList.length == 0">
                                  <div class="callout callout-warning">
                                    <i class="fa fa-info-circle"></i>
                                    {{ $ml.get('alerts.pleaseEnterAEmail') }}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <!--<div class="row">
                        <div class="col-sm-6">
                          <div class="text-center">
                            <button
                              @click="selectedMail.filterType = 0"
                              :class="selectedMail.filterType == 0 ? 'btn btn-primary active' : 'btn btn-primary'"
                            >
                              <i class="fa fa-cog"></i> {{$ml.get('mailSmsSettings.byCustomFilter')}}
                            </button>
                          </div>
                          <hr />
                          <div class="form-group">
                            <label>
                              <i class="fa fa-envelope"></i> {{$ml.get('mailSmsSettings.emailAddressesToSend')}}
                            </label>
                            <div
                              @keyup.enter="addEmail()"
                              class="input-group"
                              style="margin-bottom:7px;"
                            >
                              <input
                                :disabled="selectedMail.filterType != 0"
                                v-model="selectedEmail"
                                type="text"
                                class="form-control"
                                autocomplete="false"
                              />
                              <span class="input-group-btn">
                                <button
                                  :disabled="selectedMail.filterType != 0"
                                  @click="addEmail()"
                                  type="button"
                                  class="btn btn-primary "
                                >
                                  <i class="fa fa-plus"></i>
                                </button>
                              </span>
                            </div>
                            <ul>
                              <li v-for="(email, index) in emailList" :key="index">
                                {{email}}
                                <a
                                  :disabled="selectedMail.filterType != 0"
                                  @click="removeEmail(index)"
                                  class="text-danger"
                                >
                                  <i class="fa fa-remove"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                          <button
                            :disabled="selectedMail.filterType != 0"
                            :class="selectedMail.filter.nameOrCardNumber != '' ? 'btn btn-success' : 'btn btn-warning'"
                            data-toggle="modal"
                            data-target="#modal-filtre"
                            style="width:100%;margin-bottom:10px;"
                          >
                            <i class="fa fa-filter"></i> {{$ml.get('mailSmsSettings.filterGroup')}}
                          </button>
                        </div>
                        <div class="col-sm-6">
                          <div class="text-center">
                            <button
                              @click="selectedMail.filterType = 1"
                              :class="selectedMail.filterType == 1 ? 'btn btn-primary active' : 'btn btn-primary'"
                            >
                              <i class="fa fa-users"></i> {{$ml.get('mailSmsSettings.byAuthorizedEmployees')}}
                            </button>
                          </div>
                          <hr />
                          <div class="form-group">
                            <label>
                              <i class="fa fa-users"></i> {{$ml.get('mailSmsSettings.authorizedEmployees')}}
                            </label>
                            <div class="input-group">
                              <label
                                :disabled="selectedMail.filterType != 1"
                                class="form-control"
                              >{{$ml.get('general.notSelected')}}</label>
                              <span class="input-group-btn">
                                <button
                                  :disabled="selectedMail.filterType != 1"
                                  data-toggle="modal"
                                  data-target="#modal-kisi-sec"
                                  type="button"
                                  class="btn btn-primary "
                                >
                                  <i class="fa fa-search"></i>
                                </button>
                              </span>
                            </div>
                            <ul>
                              <li v-for="AEmp in selectedAuthorizedEmployeeList" :key="AEmp.id">
                                {{AEmp.name}}
                                <span v-if="AEmp.title != ''">- {{AEmp.title}}</span>
                                <a
                                  :disabled="selectedMail.filterType != 1"
                                  @click="AEmp.isCheck = false"
                                  class="text-danger"
                                >
                                  <i class="fa fa-remove"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>-->
                    </div>
                    <div class="box-footer text-right">
                      <button @click="deleteMail()" v-show="selectedMail.id" class="btn  btn-danger">
                        <i class="fa fa-remove"></i>
                        {{ $ml.get('general.delete') }}
                      </button>
                      <button @click="saveMail()" v-show="selectedMail.id" class="btn  btn-success">
                        <i class="fa fa-refresh"></i>
                        {{ $ml.get('general.update') }}
                      </button>
                      <button @click="saveMail()" v-show="!selectedMail.id" class="btn  btn-success">
                        <i class="fa fa-check"></i>
                        {{ $ml.get('general.save') }}
                      </button>
                    </div>
                    <div class="overlay" id="load" :hidden="!isLoading">
                      <i class="fa fa-refresh fa-spin"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Tab End-->
            <div v-show="modules.sms" class="tab-pane" id="sms-ayarlari">
              <div class="row">
                <div class="col-sm-12">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h3 class="box-title">
                        <span>
                          <i class="fa fa-bookmark"></i>
                          {{ $ml.get('mailSmsSettings.smsAPIRecordInformation') }}
                        </span>
                      </h3>
                      <div class="box-tools pull-right"></div>
                    </div>
                    <div class="box-body">
                      <div class="row">
                        <div class="form-group col-sm-6">
                          <label>{{ $ml.get('mailSmsSettings.requestSentLink') }}</label>
                          <input type="text" class="form-control" v-model="apiLink" />
                        </div>
                        <div class="form-group col-sm-6">
                          <label>{{ $ml.get('mailSmsSettings.title') }}</label>
                          <input type="text" class="form-control" v-model="baslik" />
                        </div>
                        <div class="form-group col-sm-6">
                          <label>{{ $ml.get('mailSmsSettings.apiKey') }}</label>
                          <input type="text" class="form-control" v-model="apiKey" />
                        </div>
                        <div class="form-group col-sm-6">
                          <label>{{ $ml.get('mailSmsSettings.secretKey') }}</label>
                          <input type="text" class="form-control" v-model="secretKey" />
                        </div>
                        <div class="form-group col-sm-6">
                          <label>{{ $ml.get('mailSmsSettings.userName') }}</label>
                          <input type="text" class="form-control" v-model="kullaniciAdi" />
                        </div>
                        <div class="form-group col-sm-6">
                          <label>{{ $ml.get('mailSmsSettings.password') }}</label>
                          <input type="password" class="form-control" v-model="parola" />
                        </div>
                        <div class="form-group col-sm-6">
                          <label>{{ $ml.get('mailSmsSettings.smsSystem') }}</label>
                          <span class="form-control checkbox">
                            <label style="margin-left:20px;">
                              <input :checked="aktifMi" @change="aktifMi == true ? aktifMi = false : aktifMi = true"
                                type="checkbox" />
                              {{ $ml.get('mailSmsSettings.active') }}
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" v-show="modules.sms && (modules.dormitory || modules.student)">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h3 class="box-title">
                        <span>
                          <i class="fa fa-commenting"></i>
                          {{ $ml.get('mailSmsSettings.dormitorySMSSettings') }}
                        </span>
                      </h3>
                      <div class="box-tools pull-right"></div>
                    </div>
                    <div class="box-body">
                      <div class="row">
                        <div class="form-group col-sm-12">
                          <label>1.{{ $ml.get('mailSmsSettings.smsType') }}
                            ({{ $ml.get('mailSmsSettings.smsContentDescription1') }})</label>
                          <textarea type="text" class="form-control" v-model="icerik1" />
                          <span class="text-danger">
                            <strong>{{ $ml.get('mailSmsSettings.parameters') }}:</strong>
                            {{ $ml.get('mailSmsSettings.studentName') }}
                            <strong>[ADSOYAD]</strong>
                            , {{ $ml.get('mailSmsSettings.todaysDate') }}
                            <strong>[TARIH]</strong>
                          </span>
                          <hr />
                        </div>
                        <div class="form-group col-sm-12">
                          <label>2.{{ $ml.get('mailSmsSettings.smsType') }}
                            ({{ $ml.get('mailSmsSettings.smsContentDescription2') }})</label>
                          <textarea type="text" class="form-control" v-model="icerik2" />
                          <span class="text-danger">
                            <strong>{{ $ml.get('mailSmsSettings.parameters') }}:</strong>
                            {{ $ml.get('mailSmsSettings.studentName') }}
                            <strong>[ADSOYAD]</strong>
                            , {{ $ml.get('mailSmsSettings.movementDate') }}
                            <strong>[HAREKETTARIH]</strong>
                            , {{ $ml.get('mailSmsSettings.movementTime') }}
                            <strong>[HAREKETSAAT]</strong>
                          </span>
                          <hr />
                        </div>
                        <div class="form-group col-sm-12">
                          <label>3.{{ $ml.get('mailSmsSettings.smsType') }}
                            ({{ $ml.get('mailSmsSettings.smsContentDescription3') }})</label>
                          <textarea type="text" class="form-control" v-model="icerik3" />
                          <span class="text-danger">
                            <strong>{{ $ml.get('mailSmsSettings.parameters') }}:</strong>
                            {{ $ml.get('mailSmsSettings.studentName') }}
                            <strong>[ADSOYAD]</strong>
                            , {{ $ml.get('mailSmsSettings.todaysDate') }}
                            <strong>[TARIH]</strong>
                          </span>
                          <hr />
                        </div>
                        <div class="form-group col-sm-12">
                          <label>4.{{ $ml.get('mailSmsSettings.smsType') }}
                            ({{ $ml.get('mailSmsSettings.smsContentDescription4') }})</label>
                          <textarea type="text" class="form-control" v-model="icerik4" />
                          <span class="text-danger">
                            <strong>{{ $ml.get('mailSmsSettings.parameters') }}:</strong>
                            {{ $ml.get('mailSmsSettings.studentName') }}
                            <strong>[ADSOYAD]</strong>
                            , {{ $ml.get('mailSmsSettings.allowenceStartDate') }}
                            <strong>[BASTARIH]</strong>
                            , {{ $ml.get('mailSmsSettings.allowenceEndDate') }}
                            <strong>[BITTARIH]</strong>
                            , {{ $ml.get('mailSmsSettings.allowenceName') }}
                            <strong>[IZIN]</strong>
                          </span>
                          <hr />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" v-show="modules.sms && (modules.dormitory || modules.student)">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h3 class="box-title">
                        <span>
                          <i class="fa fa-clock-o"></i>
                          {{ $ml.get('mailSmsSettings.dormitorySMSTimePlan') }}
                        </span>
                      </h3>
                      <div class="box-tools pull-right"></div>
                    </div>
                    <div class="box-body">
                      <div class="row">
                        <div class="col-sm-6 text-center">
                          <label>{{ $ml.get('general.monday') }}</label>
                          <span class="form-control checkbox">
                            <label style="margin-left:20px;">
                              <input :checked="gun1AktifMi"
                                @change="gun1AktifMi == true ? gun1AktifMi = false : gun1AktifMi = true"
                                type="checkbox" />
                              {{ $ml.get('mailSmsSettings.active') }}
                            </label>
                          </span>
                        </div>
                        <div class="form-group col-sm-6">
                          <label>{{ $ml.get('mailSmsSettings.lastEntryTime') }}</label>
                          <input type="time" class="form-control" v-model="gun1SonGiris" />
                        </div>
                        <div class="col-sm-6 text-center">
                          <label>{{ $ml.get('general.tuesday') }}</label>
                          <span class="form-control checkbox">
                            <label style="margin-left:20px;">
                              <input :checked="gun2AktifMi"
                                @change="gun2AktifMi == true ? gun2AktifMi = false : gun2AktifMi = true"
                                type="checkbox" />
                              {{ $ml.get('mailSmsSettings.active') }}
                            </label>
                          </span>
                        </div>
                        <div class="form-group col-sm-6">
                          <label>{{ $ml.get('mailSmsSettings.lastEntryTime') }}</label>
                          <input type="time" class="form-control" v-model="gun2SonGiris" />
                        </div>
                        <div class="col-sm-6 text-center">
                          <label>{{ $ml.get('general.wednesday') }}</label>
                          <span class="form-control checkbox">
                            <label style="margin-left:20px;">
                              <input :checked="gun3AktifMi"
                                @change="gun3AktifMi == true ? gun3AktifMi = false : gun3AktifMi = true"
                                type="checkbox" />
                              {{ $ml.get('mailSmsSettings.active') }}
                            </label>
                          </span>
                        </div>
                        <div class="form-group col-sm-6">
                          <label>{{ $ml.get('mailSmsSettings.lastEntryTime') }}</label>
                          <input type="time" class="form-control" v-model="gun3SonGiris" />
                        </div>
                        <div class="col-sm-6 text-center">
                          <label>{{ $ml.get('general.thursday') }}</label>
                          <span class="form-control checkbox">
                            <label style="margin-left:20px;">
                              <input :checked="gun4AktifMi"
                                @change="gun4AktifMi == true ? gun4AktifMi = false : gun4AktifMi = true"
                                type="checkbox" />
                              {{ $ml.get('mailSmsSettings.active') }}
                            </label>
                          </span>
                        </div>
                        <div class="form-group col-sm-6">
                          <label>{{ $ml.get('mailSmsSettings.lastEntryTime') }}</label>
                          <input type="time" class="form-control" v-model="gun4SonGiris" />
                        </div>
                        <div class="col-sm-6 text-center">
                          <label>{{ $ml.get('general.friday') }}</label>
                          <span class="form-control checkbox">
                            <label style="margin-left:20px;">
                              <input :checked="gun5AktifMi"
                                @change="gun5AktifMi == true ? gun5AktifMi = false : gun5AktifMi = true"
                                type="checkbox" />
                              {{ $ml.get('mailSmsSettings.active') }}
                            </label>
                          </span>
                        </div>
                        <div class="form-group col-sm-6">
                          <label>{{ $ml.get('mailSmsSettings.lastEntryTime') }}</label>
                          <input type="time" class="form-control" v-model="gun5SonGiris" />
                        </div>
                        <div class="col-sm-6 text-center">
                          <label>{{ $ml.get('general.saturday') }}</label>
                          <span class="form-control checkbox">
                            <label style="margin-left:20px;">
                              <input :checked="gun6AktifMi"
                                @change="gun6AktifMi == true ? gun6AktifMi = false : gun6AktifMi = true"
                                type="checkbox" />
                              {{ $ml.get('mailSmsSettings.active') }}
                            </label>
                          </span>
                        </div>
                        <div class="form-group col-sm-6">
                          <label>{{ $ml.get('mailSmsSettings.lastEntryTime') }}</label>
                          <input type="time" class="form-control" v-model="gun6SonGiris" />
                        </div>
                        <div class="col-sm-6 text-center">
                          <label>{{ $ml.get('general.sunday') }}</label>
                          <span class="form-control checkbox">
                            <label style="margin-left:20px;">
                              <input :checked="gun7AktifMi"
                                @change="gun7AktifMi == true ? gun7AktifMi = false : gun7AktifMi = true"
                                type="checkbox" />
                              {{ $ml.get('mailSmsSettings.active') }}
                            </label>
                          </span>
                        </div>
                        <div class="form-group col-sm-6">
                          <label>{{ $ml.get('mailSmsSettings.lastEntryTime') }}</label>
                          <input type="time" class="form-control" v-model="gun7SonGiris" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 text-right">
                  <button @click="UpdateConfig()" class="btn btn-success" style="width:100%;">
                    <i class="fa fa-refresh"></i>
                    {{ $ml.get('mailSmsSettings.updateInformation') }}
                  </button>
                </div>
              </div>
            </div>
            <!--Tab End-->
          </div>
          <!--Tab Content End-->
        </div>
      </div>
    </section>
    <!-- /.MODAL START-->
    <div class="modal modal-primary fade" id="modal-filtre">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span>{{ $ml.get('filters.filterEmployees') }}</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <span>{{ $ml.get('filters.filterNameSurnameOrCardNo') }}</span>
                  <input v-model="selectedMail.filter.nameOrCardNumber" type="text" class="form-control input-sm"
                    :placeholder="$ml.get('filters.filterNameSurnameOrCardNo')" style="margin-bottom:5px;" />
                </div>
                <div class="form-group">
                  <span>{{ $ml.get('filters.filterCitizenshipNumber') }}</span>
                  <input v-model="selectedMail.filter.identityNo" type="text" class="form-control input-sm"
                    :placeholder="$ml.get('filters.filterCitizenshipNumber')" style="margin-bottom:5px;" />
                </div>
                <div class="form-group">
                  <span>{{ $ml.get('filters.filterRegistrationOrDeviceNo') }}</span>
                  <input v-model="selectedMail.filter.sicilOrTerminalNo" type="text" class="form-control input-sm"
                    :placeholder="$ml.get('filters.filterRegistrationOrDeviceNo')" style="margin-bottom:5px;" />
                </div>
                <div class="form-group">
                  <span>{{ $ml.get('filters.filterDocumentNoOrEmail') }}</span>
                  <input v-model="selectedMail.filter.documentNoOrMail" type="text" class="form-control input-sm"
                    :placeholder="$ml.get('filters.filterDocumentNoOrEmail')" style="margin-bottom:5px;" />
                </div>
                <div class="form-group" v-show="modules.licencePlateRecognition">
                  <span>{{ $ml.get('filters.filterPlateNo') }}</span>
                  <input v-model="selectedMail.filter.plateNo" type="text" class="form-control input-sm"
                    :placeholder="$ml.get('filters.filterPlateNo')" style="margin-bottom:5px;" />
                </div>
                <div class="form-group">
                  <label>{{ $ml.get('filters.filterStatus') }}</label>
                  <div class="input-group">
                    <label v-show="checkedStatusList != ''" class="form-control tdb-box">{{ checkedStatusList }}</label>
                    <label v-show="checkedStatusList == ''" class="form-control">{{ $ml.get('general.notSelected')
                    }}</label>
                    <div class="input-group-btn">
                      <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-status">
                        <i class="fa fa-search"></i>
                      </button>
                      <button v-show="checkedStatusList != ''" class="btn btn-danger" @click="clearFilterStatus()">
                        <i class="fa fa-remove"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>{{ $ml.get('filters.filterState') }}</label>
                  <div class="input-group">
                    <label v-show="checkedStateList != ''" class="form-control tdb-box">{{ checkedStateList }}</label>
                    <label v-show="checkedStateList == ''" class="form-control">{{ $ml.get('general.notSelected')
                    }}</label>
                    <div class="input-group-btn">
                      <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-state">
                        <i class="fa fa-search"></i>
                      </button>
                      <button v-show="checkedStateList != ''" class="btn btn-danger" @click="clearFilterStates()">
                        <i class="fa fa-remove"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <span>{{ $ml.get('filters.filterTitle') }}</span>
                  <select @change="changeFilterTitles($event)" class="form-control input-sm" style="margin-bottom:5px;">
                    <option :selected="selectedMail.filter.title == ''" value>{{ $ml.get('general.select') }}</option>
                    <option v-for="title in titleList" :key="title.name" :value="title.name"
                      :selected="title.name == selectedMail.filter.title">{{ title.name }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>{{ $ml.get('filters.filterDepartments') }}</label>
                  <div class="input-group">
                    <label v-show="checkedDepartmentList != ''" class="form-control tdb-box">{{ checkedDepartmentList
                    }}</label>
                    <label v-show="checkedDepartmentList == ''" class="form-control">{{ $ml.get('general.notSelected')
                    }}</label>
                    <div class="input-group-btn">
                      <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-department">
                        <i class="fa fa-search"></i>
                      </button>
                      <button v-show="checkedDepartmentList != ''" class="btn btn-danger"
                        @click="clearFilterDepartments()">
                        <i class="fa fa-remove"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>{{ $ml.get('filters.filterAccessGroup') }}</label>
                  <div class="input-group">
                    <label v-show="checkedAccessGroupList != ''" class="form-control tdb-box">{{ checkedAccessGroupList
                    }}</label>
                    <label v-show="checkedAccessGroupList == ''" class="form-control">{{ $ml.get('general.notSelected')
                    }}</label>
                    <div class="input-group-btn">
                      <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-access">
                        <i class="fa fa-search"></i>
                      </button>
                      <button v-show="checkedAccessGroupList != ''" class="btn btn-danger"
                        @click="clearFilterAccessGroup()">
                        <i class="fa fa-remove"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>{{ $ml.get('filters.filterWorkPlan') }}</label>
                  <div class="input-group">
                    <label v-show="checkedWorkGroupList != ''" class="form-control tdb-box">{{ checkedWorkGroupList
                    }}</label>
                    <label v-show="checkedWorkGroupList == ''" class="form-control">{{ $ml.get('general.notSelected')
                    }}</label>
                    <div class="input-group-btn">
                      <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-workplan">
                        <i class="fa fa-search"></i>
                      </button>
                      <button v-show="checkedWorkGroupList != ''" class="btn btn-danger"
                        @click="clearFilterWorkPlans()">
                        <i class="fa fa-remove"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group" v-show="modules.diningHall">
                  <label>{{ $ml.get('filters.filterFoodGroup') }}</label>
                  <div class="input-group">
                    <label v-show="checkedFoodGroupList != ''" class="form-control tdb-box">{{ checkedFoodGroupList
                    }}</label>
                    <label v-show="checkedFoodGroupList == ''" class="form-control">{{ $ml.get('general.notSelected')
                    }}</label>
                    <div class="input-group-btn">
                      <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-diningHall">
                        <i class="fa fa-search"></i>
                      </button>
                      <button v-show="checkedFoodGroupList != ''" class="btn btn-danger"
                        @click="clearFilterFoodGroups()">
                        <i class="fa fa-remove"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-sm-6">
                    <span>{{ $ml.get('filters.filterDeleted') }}</span>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :checked="selectedMail.filter.isActive"
                          @change="selectedMail.filter.isActive == true ? selectedMail.filter.isActive = false : selectedMail.filter.isActive = true"
                          type="checkbox" />
                        {{ $ml.get('filters.filterNotShow') }}
                      </label>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="callout callout-info" style="margin-top:10px;">
              <div class="row">
                <div class="col-md-3 col-xs-6">
                  <select @change="changeFilterExtraField1($event)" class="form-control input-sm"
                    style="margin-bottom:5px;">
                    <option :selected="selectedMail.filter.extraField1key == 0" value>
                      {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                    <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                      :selected="extraField.id == selectedMail.filter.extraField1key">{{ extraField.name }}</option>
                  </select>
                </div>
                <div class="col-md-3 col-xs-6">
                  <input v-model="selectedMail.filter.extraField1value" type="text" class="form-control input-sm"
                    :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                </div>
                <div class="col-md-3 col-xs-6">
                  <select @change="changeFilterExtraField2($event)" class="form-control input-sm"
                    style="margin-bottom:5px;">
                    <option :selected="selectedMail.filter.extraField2key == 0" value>
                      {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                    <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                      :selected="extraField.id == selectedMail.filter.extraField2key">{{ extraField.name }}</option>
                  </select>
                </div>
                <div class="col-md-3 col-xs-6">
                  <input v-model="selectedMail.filter.extraField2value" type="text" class="form-control input-sm"
                    :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                </div>
                <div class="col-md-3 col-xs-6">
                  <select @change="changeFilterExtraField3($event)" class="form-control input-sm"
                    style="margin-bottom:5px;">
                    <option :selected="selectedMail.filter.extraField3key == 0" value>
                      {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                    <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                      :selected="extraField.id == selectedMail.filter.extraField3key">{{ extraField.name }}</option>
                  </select>
                </div>
                <div class="col-md-3 col-xs-6">
                  <input v-model="selectedMail.filter.extraField3value" type="text" class="form-control input-sm"
                    :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                </div>
                <div class="col-md-3 col-xs-6">
                  <select @change="changeFilterExtraField4($event)" class="form-control input-sm"
                    style="margin-bottom:5px;">
                    <option :selected="selectedMail.filter.extraField4key == 0" value>
                      {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                    <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                      :selected="extraField.id == selectedMail.filter.extraField4key">{{ extraField.name }}</option>
                  </select>
                </div>
                <div class="col-md-3 col-xs-6">
                  <input v-model="selectedMail.filter.extraField4value" type="text" class="form-control input-sm"
                    :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">
            <i class="fa fa-remove"></i>
            <span>{{ $ml.get('filters.filterCancel') }}</span>
          </button>
          <button @click="filtersClear()" class="btn btn-warning ">
            <i class="fa fa-trash-o"></i>
            <span>{{ $ml.get('filters.filterClear') }}</span>
          </button>
          <button @click="setFilter()" class="btn btn-success " data-dismiss="modal">
            <i class="fa fa-check"></i>
            <span>{{ $ml.get('filters.filterComplete') }}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- /.MODAL END -->
    <!--DEPARTMAN SEÇ MODAL -->
    <div class="modal modal-secondary fade" id="modal-select-department" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span>{{ $ml.get('filters.filterDepartments') }}</span>
            </h4>
          </div>
          <div class="modal-body">
            <a @click="isCheckDeps == true ? getCheckDepartmentAll(false) : getCheckDepartmentAll(true)">
              <span v-text="isCheckDeps == true ? $ml.get('general.removeAll') : $ml.get('general.selectAll')"></span>
            </a>
            <div class="table-responsive" style="max-height:600px;owerflow:auto;">
              <span class="form-control checkbox" v-for="dep in sortableDepartmentList" :key="dep.id">
                <label style="margin-left:20px;">
                  <input :checked="dep.check"
                    @change="dep.check == true ? changeFilterDep(dep, false) : changeFilterDep(dep, true)"
                    type="checkbox" />
                  {{ dep.name }}
                </label>
              </span>
              <div class="callout callout-warning" v-show="sortableDepartmentList.length == 0">
                {{ $ml.get('employees.departmentNotRecord') }}</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              <i class="fa fa-check"></i>
              {{ $ml.get('general.done') }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--DEPARTMAN SEÇ MODAL END -->
    <!--DURUM SEÇ MODAL -->
    <div class="modal modal-secondary fade" id="modal-select-state" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span>{{ $ml.get('filters.filterState') }}</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="table-responsive" style="max-height:600px;owerflow:auto;">
              <span class="form-control checkbox" v-for="state in stateList" :key="state.id">
                <label style="margin-left:20px;">
                  <input :checked="state.isCheck"
                    @change="state.isCheck == true ? state.isCheck = false : state.isCheck = true" type="checkbox" />
                  {{ state.name }}
                </label>
              </span>
              <div class="callout callout-warning" v-show="stateList.length == 0">
                {{ $ml.get('employees.stateNotRecord') }}</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              <i class="fa fa-check"></i>
              {{ $ml.get('general.done') }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--DURUM SEÇ MODAL END -->
    <!--STATU SEÇ MODAL -->
    <div class="modal modal-secondary fade" id="modal-select-status" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span>{{ $ml.get('filters.filterStatus') }}</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="table-responsive" style="max-height:600px;owerflow:auto;">
              <span class="form-control checkbox" v-for="status in statuList" :key="status.id">
                <label style="margin-left:20px;">
                  <input :checked="status.isCheck"
                    @change="status.isCheck == true ? status.isCheck = false : status.isCheck = true" type="checkbox" />
                  {{ status.name }}
                </label>
              </span>
              <div class="callout callout-warning" v-show="statuList.length == 0">
                {{ $ml.get('employees.statusNotRecord') }}</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              <i class="fa fa-check"></i>
              {{ $ml.get('general.done') }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--STATU SEÇ MODAL END -->
    <!--GEÇİŞ GRUBU SEÇ MODAL -->
    <div class="modal modal-secondary fade" id="modal-select-access" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span>{{ $ml.get('filters.filterAccessGroup') }}</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="table-responsive" style="max-height:600px;owerflow:auto;">
              <span class="form-control checkbox" v-for="acc in accessGroupList" :key="acc.id">
                <label style="margin-left:20px;">
                  <input :checked="acc.isCheck" @change="acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true"
                    type="checkbox" />
                  {{ acc.name }}
                </label>
              </span>
              <div class="callout callout-warning" v-show="accessGroupList.length == 0">
                {{ $ml.get('accessGroups.accessGroupNotRecord') }}</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              <i class="fa fa-check"></i>
              {{ $ml.get('general.done') }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--GEÇİŞ GRUBU SEÇ MODAL END -->
    <!--ÇALIŞMA PLANI SEÇ MODAL -->
    <div class="modal modal-secondary fade" id="modal-select-workplan" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="table-responsive" style="max-height:600px;owerflow:auto;">
              <span class="form-control checkbox" v-for="work in periodWorkGroupList" :key="work.id">
                <label style="margin-left:20px;">
                  <input :checked="work.isCheck"
                    @change="work.isCheck == true ? work.isCheck = false : work.isCheck = true" type="checkbox" />
                  {{ work.name }}
                </label>
              </span>
              <div class="callout callout-warning" v-show="periodWorkGroupList.length == 0">
                {{ $ml.get('workPlans.workPlanNotRecord') }}</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              <i class="fa fa-check"></i>
              {{ $ml.get('general.done') }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--ÇALIŞMA PLANI SEÇ MODAL END -->
    <!--YEMEK PLANI SEÇ MODAL -->
    <div class="modal modal-secondary fade" id="modal-select-diningHall" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="table-responsive" style="max-height:600px;owerflow:auto;">
              <span class="form-control checkbox" v-for="foodGroup in foodGroupList" :key="foodGroup.id">
                <label style="margin-left:20px;">
                  <input :checked="foodGroup.isCheck"
                    @change="foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true"
                    type="checkbox" />
                  {{ foodGroup.name }}
                </label>
              </span>
              <div class="callout callout-warning" v-show="foodGroupList.length == 0">
                {{ $ml.get('foodGroups.foodGroupNotRecord') }}</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              <i class="fa fa-check"></i>
              {{ $ml.get('general.done') }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--YEMEK PLANI SEÇ MODAL END -->
    <!-- /.MODAL START-->
    <div class="modal modal-xl fade" id="modal-kisi-sec">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span>{{ $ml.get('employees.selectEmployee') }}</span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <input v-model="searchText" class="form-control"
                  :placeholder="$ml.get('employees.searchFromNameSurname')" />
              </div>
              <div class="col-sm-12">
                <div v-show="allEmployeeFilteredList.length > 0" class="table-responsive no-padding"
                  style="max-height:500px;owerflow:auto;">
                  <table class="table table-hover">
                    <tbody>
                      <tr>
                        <th>{{ $ml.get('employees.employeeList') }}</th>
                      </tr>
                      <tr v-for="employee in allEmployeeFilteredList" :key="employee.id">
                        <td class="checkbox">
                          <label style="margin-left:20px;">
                            <input :checked="employee.isCheck"
                              @change="employee.isCheck == true ? employee.isCheck = false : employee.isCheck = true"
                              type="checkbox" />
                            {{ employee.name }}
                            <span v-if="employee.title != ''">- {{ employee.title }}</span>
                          </label>
                        </td>
                        <!--<button
                          @click="selectAuthorizedEmployee(employee.id)"
                          data-dismiss="modal"
                          type="button"
                          class="btn btn-primary btn-sm"
                        >
                          <i class="fa fa-check"></i>
                        </button>-->
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-show="allEmployeeFilteredList.length == 0" class="callout callout-info">
                  <i class="fa fa-info-circle"></i>
                  {{ $ml.get('employees.employeeSearchNotFound') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.MODAL END -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      mails: [],
      selectedReport: 0,
      selectedEmail: "",
      selectedMail: {
        id: 0,
        name: "",
        header: "",
        content: "",
        reports: [],
        emails: [],
        days: [],
        time: null,
        isActive: true,
        reportType: 0,
        filterType: 0,
        filter: {
          nameOrCardNumber: "",
          sicilOrTerminalNo: null,
          departments: [],
          isActive: true,
          documentNoOrMail: "",
          accessGroup: [],
          identityNo: "",
          foodGroup: [],
          workGroupId: [],
          title: "",
          stateId: [],
          statuId: [],
          extraField1key: 0,
          extraField1value: "",
          extraField2key: 0,
          extraField2value: "",
          extraField3key: 0,
          extraField3value: "",
          extraField4key: 0,
          extraField4value: "",
          isVisitor: false,
          plateNo: ""
        },
        authorizedUsers: [0]
      },
      searchText: "",
      allEmployees: [],
      departments: [],
      isCheckDeps: false,
      sortableDepTrees: [],
      foodGroups: [],
      accessGroups: [],
      extrafields: [],
      states: [],
      status: [],
      titles: [],
      workGroups: [],
      days: [
        { value: 1, name: this.$ml.get("general.monday"), check: false },
        { value: 2, name: this.$ml.get("general.tuesday"), check: false },
        { value: 3, name: this.$ml.get("general.wednesday"), check: false },
        { value: 4, name: this.$ml.get("general.thursday"), check: false },
        { value: 5, name: this.$ml.get("general.friday"), check: false },
        { value: 6, name: this.$ml.get("general.saturday"), check: false },
        { value: 7, name: this.$ml.get("general.sunday"), check: false }
      ],
      apiLink: "",
      baslik: "",
      apiKey: "",
      secretKey: "",
      kullaniciAdi: "",
      parola: "",
      aktifMi: true,
      icerik1: "",
      icerik2: "",
      icerik3: "",
      icerik4: "",
      gun1AktifMi: true,
      gun1SonGiris: null,
      gun2AktifMi: true,
      gun2SonGiris: null,
      gun3AktifMi: true,
      gun3SonGiris: null,
      gun4AktifMi: true,
      gun4SonGiris: null,
      gun5AktifMi: true,
      gun5SonGiris: null,
      gun6AktifMi: true,
      gun6SonGiris: null,
      gun7AktifMi: true,
      gun7SonGiris: null,
      reports: [
        {
          id: 1,
          name: this.$ml.get("reports.reports.LaterComersReport"),
          endPoint: "LaterComersReport",
          isActive: false,
          checked: false
        },
        {
          id: 11,
          name: this.$ml.get("reports.reports.FirstInLastOutReport"),
          endPoint: "FirstInLastOutReport",
          isActive: false,
          checked: false
        },
        {
          id: 3,
          name: this.$ml.get("reports.reports.FoodReport"),
          endPoint: "FoodReport",
          isActive: false,
          checked: false
        },
      ]
    };
  },
  computed: {
    modules() {
      return this.$store.getters.getModules;
    },
    dayList() {
      return this.days;
    },
    reportList() {
      return this.reports;
    },
    checkedReportList() {
      return this.reports.filter(report => report.checked);
    },
    mailList() {
      return this.mails;
    },
    emailList() {
      return this.selectedMail.emails;
    },
    selectedReportList() {
      return this.selectedMail.reports;
    },
    allEmployeeList() {
      return this.allEmployees;
    },
    allEmployeeFilteredList() {
      if (this.searchText) {
        return this.allEmployeeList.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(v => item.name.toUpperCase().includes(v));
        });
      } else {
        return this.allEmployeeList;
      }
    },
    selectedAuthorizedEmployeeList() {
      return this.allEmployeeList.filter(a => {
        return a.isCheck == true;
      });
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    sortableDepartmentList() {
      if (this.searchText) {
        return this.sortableDepTrees.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(v => item.name.toUpperCase().includes(v));
        });
      } else {
        return this.sortableDepTrees;
      }
    },
    checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(a => {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    extraFieldList() {
      return this.extrafields;
    },
    foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    stateList() {
      return this.states;
    },
    checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList() {
      return this.status;
    },
    checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    titleList() {
      return this.titles;
    },
    periodWorkGroupList() {
      return this.workGroups.filter(item => {
        return item.isPeriod == true || item.model == 4 || item.model == 3;
      });
    },
    checkedWorkGroupList() {
      var checkedList = "";
      var list = this.periodWorkGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    //Filters
    changeFilterTitles(event) {
      this.selectedMail.filter.title = event.target.value;
    },
    changeFilterExtraField1(event) {
      this.selectedMail.filter.extraField1key = event.target.value;
      if (!this.selectedMail.filter.extraField1key) {
        this.selectedMail.filter.extraField1key = 0;
      }
    },
    changeFilterExtraField2(event) {
      this.selectedMail.filter.extraField2key = event.target.value;
      if (!this.selectedMail.filter.extraField2key) {
        this.selectedMail.filter.extraField2key = 0;
      }
    },
    changeFilterExtraField3(event) {
      this.selectedMail.filter.extraField3key = event.target.value;
      if (!this.selectedMail.filter.extraField3key) {
        this.selectedMail.filter.extraField3key = 0;
      }
    },
    changeFilterExtraField4(event) {
      this.selectedMail.filter.extraField4key = event.target.value;
      if (!this.selectedMail.filter.extraField4key) {
        this.selectedMail.filter.extraField4key = 0;
      }
    },
    async clearFilterDepartments() {
      this.selectedMail.filter.departments = [];
      await this.sortableDepartmentList.forEach(doc => {
        if (doc.check == true) {
          doc.check = false;
        }
      });
    },
    async clearFilterAccessGroup() {
      this.selectedMail.filter.accessGroup = [];
      await this.accessGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStates() {
      this.selectedMail.filter.stateId = [];
      await this.stateList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStatus() {
      this.selectedMail.filter.statuId = [];
      await this.statuList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterWorkPlans() {
      this.selectedMail.filter.workGroupId = [];
      await this.periodWorkGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterFoodGroups() {
      this.selectedMail.filter.foodGroup = [];
      await this.foodGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async getCheckDepartmentList() {
      let aList = this.sortableDepartmentList;
      this.selectedMail.filter.departments = [];
      await aList.forEach(doc => {
        if (doc.check == true) {
          this.selectedMail.filter.departments.push(doc.id);
        }
      });
      let aList2 = this.accessGroupList;
      this.selectedMail.filter.accessGroup = [];
      await aList2.forEach(doc => {
        if (doc.isCheck == true) {
          this.selectedMail.filter.accessGroup.push(doc.id);
        }
      });
      let aList3 = this.periodWorkGroupList;
      this.selectedMail.filter.workGroupId = [];
      await aList3.forEach(doc => {
        if (doc.isCheck == true) {
          this.selectedMail.filter.workGroupId.push(doc.id);
        }
      });
      let aList4 = this.foodGroupList;
      this.selectedMail.filter.foodGroup = [];
      await aList4.forEach(doc => {
        if (doc.isCheck == true) {
          this.selectedMail.filter.foodGroup.push(doc.id);
        }
      });
      let aList5 = this.statuList;
      this.selectedMail.filter.statuId = [];
      await aList5.forEach(doc => {
        if (doc.isCheck == true) {
          this.selectedMail.filter.statuId.push(doc.id);
        }
      });
      let aList6 = this.stateList;
      this.selectedMail.filter.stateId = [];
      await aList6.forEach(doc => {
        if (doc.isCheck == true) {
          this.selectedMail.filter.stateId.push(doc.id);
        }
      });
    },
    async setFilter() {
      await this.getCheckDepartmentList();
    },
    filtersClear() {
      this.selectedMail.filter.nameOrCardNumber = "";
      this.selectedMail.filter.sicilOrTerminalNo = null;
      this.selectedMail.filter.departments = [];
      this.selectedMail.filter.accessGroup = [];
      this.selectedMail.filter.identityNo = "";
      this.selectedMail.filter.documentNoOrMail = "";
      this.selectedMail.filter.foodGroup = [];
      this.selectedMail.filter.workGroupId = [];
      this.selectedMail.filter.title = "";
      this.selectedMail.filter.stateId = [];
      this.selectedMail.filter.statuId = [];
      this.selectedMail.filter.plateNo = "";
      this.selectedMail.filter.extraField1key = 0;
      this.selectedMail.filter.extraField1value = "";
      this.selectedMail.filter.extraField2key = 0;
      this.selectedMail.filter.extraField2value = "";
      this.selectedMail.filter.extraField3key = 0;
      this.selectedMail.filter.extraField3value = "";
      this.selectedMail.filter.extraField4key = 0;
      this.selectedMail.filter.extraField4value = "";
      this.selectedMail.filter.isVisitor = false;
      this.selectedMail.filter.isActive = true;
      this.accessGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(a => {
        a.check = false;
      });
      this.foodGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.periodWorkGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.stateList.forEach(a => {
        a.isCheck = false;
      });
      this.statuList.forEach(a => {
        a.isCheck = false;
      });
    },
    async getCheckDepAll(value) {
      this.sortableDepartmentList.forEach(dep => {
        dep.check = value;
      });
      this.isCheckDep = !this.isCheckDep;
    },
    async getCheckDepartmentAll(value) {
      this.sortableDepartmentList.forEach(dep => {
        dep.check = value;
      });
      this.isCheckDeps = !this.isCheckDeps;
    },
    async changeFilterDep(dep, checkValue) {
      dep.check = checkValue;
      this.sortableDepartmentList.forEach(doc => {
        if (doc.mainDepartmentId == dep.id) {
          doc.check = checkValue;
          this.changeFilterDep(doc, checkValue);
        }
      });
    },
    async getCheckDepartmentList() {
      let aList = this.sortableDepartmentList;
      this.selectedMail.filter.departments = [];
      await aList.forEach(doc => {
        if (doc.check == true) {
          this.selectedMail.filter.departments.push(doc.id);
        }
      });
    },
    async getDepartments() {
      try {
        this.isLoadingDetail = true;
        const departments = [];
        const response = await this.$axios
          .get("/Department")
          .then(response => {
            response.data.forEach(doc => {
              departments.push({
                id: doc.id,
                name: doc.name,
                mainDepartmentId: doc.mainDepartmentId,
                isActive: doc.isActive,
                locationTree: doc.locationTree,
                check: false
              });
              departments.sort((a, b) => {
                if (a.locationTree < b.locationTree) return -1;
                if (a.locationTree > b.locationTree) return 0;
              });
            });
            this.departments = departments;
            this.sortableTrees();
            this.isLoadingDetail = false;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    sortableTrees() {
      this.sortableDepTrees = [];
      this.departments.forEach(dep => {
        if (dep.mainDepartmentId == null) {
          this.sortableDepTrees.push(dep);
          this.subDepImport(dep);
        }
      });
    },
    subDepImport(dep) {
      let subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        let ek = subDep[0].locationTree.split("/");
        for (let index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(doc2 => {
          this.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          this.subDepImport(doc2);
        });
      }
    },
    async getFoodGroups() {
      try {
        const foodGroups = [];
        const response = await this.$axios
          .get("/FoodGroups")
          .then(response => {
            response.data.forEach(doc => {
              foodGroups.push({
                id: doc.id,
                name: doc.name,
                type: doc.type,
                singleFoodEachMeal: doc.singleFoodEachMeal,
                meals: doc.meals,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.foodGroups = foodGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getExtraFields() {
      try {
        const extrafields = [];
        const response = await this.$axios
          .get("/ExtraField")
          .then(response => {
            response.data.forEach(doc => {
              extrafields.push({
                id: doc.id,
                name: doc.definition
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.extrafields = extrafields;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStatus() {
      try {
        const status = [];
        const response = await this.$axios
          .get("/Employees/getStatus")
          .then(response => {
            response.data.forEach(doc => {
              status.push({
                id: doc.id,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.status = status;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStates() {
      try {
        const states = [];
        const response = await this.$axios
          .get("/Employees/getStates")
          .then(response => {
            response.data.forEach(doc => {
              states.push({
                id: doc.id,
                name: doc.name,
                status: doc.status,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.states = states;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getAccessGroups() {
      try {
        const accessGroups = [];
        const response = await this.$axios
          .get("/AccessGroups")
          .then(response => {
            response.data.forEach(doc => {
              accessGroups.push({
                id: doc.id,
                name: doc.name,
                isNewReaderAdd: doc.isNewReaderAdd,
                selectedReaders: doc.postReaders,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.accessGroups = accessGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getWorkGroups() {
      try {
        const workGroups = [];
        const response = await this.$axios
          .get("/WorkGroups")
          .then(response => {
            response.data.forEach(doc => {
              workGroups.push({
                id: doc.id,
                name: doc.name,
                shortCode: doc.shortCode,
                isPeriod: doc.isPeriod,
                isCheck: false
              });
              workGroups.sort((a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 0;
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.workGroups = workGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getTitles() {
      try {
        const titles = [];
        const response = await this.$axios
          .get("/Employees/getTitles")
          .then(response => {
            response.data.forEach(doc => {
              titles.push({
                name: doc
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.titles = titles;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    //End Filters
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    getEmpNameFromId(id) {
      let aList = this.allEmployees;
      let emp = aList.filter(function (emp) {
        return emp.id == id;
      });
      if (emp != "" && emp != null) {
        let title = "";
        if (emp[0].title != "") {
          title = " - " + emp[0].title;
        }
        return emp[0].name + title;
      } else {
        return null;
      }
    },
    async getConfig() {
      try {
        const response = await this.$axios
          .get("/SmsConfig")
          .then(response => {
            this.apiLink = response.data.apiLink;
            this.baslik = response.data.baslik;
            this.apiKey = response.data.apiKey;
            this.secretKey = response.data.secretKey;
            this.kullaniciAdi = response.data.kullaniciAdi;
            this.parola = response.data.parola;
            this.aktifMi = response.data.aktifMi;
            this.icerik1 = response.data.icerik1;
            this.icerik2 = response.data.icerik2;
            this.icerik3 = response.data.icerik3;
            this.icerik4 = response.data.icerik4;
            this.gun1AktifMi = response.data.gun1AktifMi;
            this.gun1SonGiris = response.data.gun1SonGiris
              ? this.toDateFormat(response.data.gun1SonGiris, "ss:dd")
              : "";
            this.gun2AktifMi = response.data.gun2AktifMi;
            this.gun2SonGiris = response.data.gun2SonGiris
              ? this.toDateFormat(response.data.gun2SonGiris, "ss:dd")
              : "";
            this.gun3AktifMi = response.data.gun3AktifMi;
            this.gun3SonGiris = response.data.gun3SonGiris
              ? this.toDateFormat(response.data.gun3SonGiris, "ss:dd")
              : "";
            this.gun4AktifMi = response.data.gun4AktifMi;
            this.gun4SonGiris = response.data.gun4SonGiris
              ? this.toDateFormat(response.data.gun4SonGiris, "ss:dd")
              : "";
            this.gun5AktifMi = response.data.gun5AktifMi;
            this.gun5SonGiris = response.data.gun5SonGiris
              ? this.toDateFormat(response.data.gun5SonGiris, "ss:dd")
              : "";
            this.gun6AktifMi = response.data.gun6AktifMi;
            this.gun6SonGiris = response.data.gun6SonGiris
              ? this.toDateFormat(response.data.gun6SonGiris, "ss:dd")
              : "";
            this.gun7AktifMi = response.data.gun7AktifMi;
            this.gun7SonGiris = response.data.gun7SonGiris
              ? this.toDateFormat(response.data.gun7SonGiris, "ss:dd")
              : "";
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async UpdateConfig() {
      try {
        const response = await this.$axios
          .post("/SmsConfig", {
            apiLink: this.apiLink,
            baslik: this.baslik,
            apiKey: this.apiKey,
            secretKey: this.secretKey,
            kullaniciAdi: this.kullaniciAdi,
            parola: this.parola,
            aktifMi: this.aktifMi,
            icerik1: this.icerik1,
            icerik2: this.icerik2,
            icerik3: this.icerik3,
            icerik4: this.icerik4,
            gun1AktifMi: this.gun1AktifMi,
            gun1SonGiris: this.gun1SonGiris,
            gun2AktifMi: this.gun2AktifMi,
            gun2SonGiris: this.gun2SonGiris,
            gun3AktifMi: this.gun3AktifMi,
            gun3SonGiris: this.gun3SonGiris,
            gun4AktifMi: this.gun4AktifMi,
            gun4SonGiris: this.gun4SonGiris,
            gun5AktifMi: this.gun5AktifMi,
            gun5SonGiris: this.gun5SonGiris,
            gun6AktifMi: this.gun6AktifMi,
            gun6SonGiris: this.gun6SonGiris,
            gun7AktifMi: this.gun7AktifMi,
            gun7SonGiris: this.gun7SonGiris
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    validateEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      } else {
        return false;
      }
    },
    addEmail() {
      if (this.selectedEmail != "" && this.validateEmail(this.selectedEmail)) {
        this.selectedMail.emails.push(this.selectedEmail);
        this.selectedEmail = "";
      } else {
        alertify.warning(this.$ml.get("alerts.wrongEmail"));
      }
    },
    removeEmail(index) {
      this.emailList.splice(index, 1);
    },
    deleteMail() {
      try {
        let id = this.selectedMail.id;
        if (id != null && id != 0) {
          const response = this.$axios
            .delete("/Mail?id=" + id)
            .then(response => {
              this.getMails();
              this.newMail();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    async saveMail() {
      if (
        this.selectedMail.name == "" ||
        this.selectedMail.header == "" ||
        this.selectedMail.content == "" ||
        this.selectedMail.emails == [] ||
        this.selectedMail.days == [] ||
        this.selectedMail.time == null ||
        this.checkedReportList.length == 0
      ) {
        alertify.warning(this.$ml.get("alerts.pleaseCheckEmptyFields"));
        return;
      }
      this.selectedMail.reports = [];
      this.checkedReportList.forEach(doc => {
        this.selectedMail.reports.push(doc.id);
      });
      this.selectedMail.days = [];
      this.dayList.forEach(doc => {
        if (doc.check) {
          this.selectedMail.days.push(doc.value);
        }
      });
      if (this.selectedMail.id == 0) {
        //KAYDET
        const response = await this.$axios
          .post("/Mail", this.selectedMail)
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              this.newMail();
              this.getMails();
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
      } else {
        //GÜNCELLE
        const response = await this.$axios
          .put("/Mail/", this.selectedMail)
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
              this.newMail();
              this.getMails();
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
      }
    },
    newMail() {
      this.selectedReport = 0;
      this.selectedMail.id = 0;
      this.selectedMail.name = "";
      this.selectedMail.header = "";
      this.selectedMail.content = "";
      this.selectedMail.reports = [];
      this.selectedMail.emails = [];
      this.selectedMail.days = [];
      this.selectedMail.time = null;
      this.selectedMail.isActive = true;
      this.selectedMail.reportType = 0;
      this.selectedMail.filterType = 0;
      this.selectedMail.filter.nameOrCardNumber = "";
      this.selectedMail.filter.sicilOrTerminalNo = null;
      this.selectedMail.filter.departments = [];
      this.selectedMail.filter.isActive = true;
      this.selectedMail.filter.documentNoOrMail = "";
      this.selectedMail.filter.accessGroup = [];
      this.selectedMail.filter.identityNo = "";
      this.selectedMail.filter.foodGroup = [];
      this.selectedMail.filter.workGroupId = [];
      this.selectedMail.filter.title = "";
      this.selectedMail.filter.stateId = [];
      this.selectedMail.filter.statuId = [];
      this.selectedMail.filter.extraField1key = 0;
      this.selectedMail.filter.extraField1value = "";
      this.selectedMail.filter.extraField2key = 0;
      this.selectedMail.filter.extraField2value = "";
      this.selectedMail.filter.extraField3key = 0;
      this.selectedMail.filter.extraField3value = "";
      this.selectedMail.filter.extraField4key = 0;
      this.selectedMail.filter.extraField4value = "";
      this.selectedMail.filter.isVisitor = false;
      this.selectedMail.filter.plateNo = "";
      this.selectedMail.authorizedUsers = [];
      this.dayList.forEach(doc => {
        doc.check = false;
      });
      this.reports.forEach(doc => {
        doc.checked = false;
      });
      this.filtersClear();
    },
    getFilter(filter) {
      this.sortableDepartmentList.forEach(doc => {
        this.selectedMail.filter.departments.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.periodWorkGroupList.forEach(doc => {
        this.selectedMail.filter.workGroupId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(doc => {
        this.selectedMail.filter.accessGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(doc => {
        this.selectedMail.filter.foodGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(doc => {
        this.selectedMail.filter.stateId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(doc => {
        this.selectedMail.filter.statuId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    getMail(mail) {
      this.selectedMail.id = mail.id;
      this.selectedMail.name = mail.name;
      this.selectedMail.header = mail.header;
      this.selectedMail.content = mail.content;
      this.selectedMail.reports = mail.reports;
      this.selectedMail.emails = mail.emails;
      this.selectedMail.days = mail.days;
      this.selectedMail.time = mail.time;
      this.selectedMail.isActive = mail.isActive;
      this.selectedMail.reportType = mail.reportType;
      this.selectedMail.filterType = mail.filterType;
      this.selectedMail.filter.nameOrCardNumber = mail.filter.nameOrCardNumber;
      this.selectedMail.filter.sicilOrTerminalNo = mail.filter.sicilOrTerminalNo;
      this.selectedMail.filter.departments = mail.filter.departments;
      this.selectedMail.filter.isActive = mail.filter.isActive;
      this.selectedMail.filter.documentNoOrMail = mail.filter.documentNoOrMail;
      this.selectedMail.filter.accessGroup = mail.filter.accessGroup;
      this.selectedMail.filter.identityNo = mail.filter.identityNo;
      this.selectedMail.filter.foodGroup = mail.filter.foodGroup;
      this.selectedMail.filter.workGroupId = mail.filter.workGroupId;
      this.selectedMail.filter.title = mail.filter.title;
      this.selectedMail.filter.stateId = mail.filter.stateId;
      this.selectedMail.filter.statuId = mail.filter.statuId;
      this.selectedMail.filter.extraField1key = mail.filter.extraField1key;
      this.selectedMail.filter.extraField1value = mail.filter.extraField1value;
      this.selectedMail.filter.extraField2key = mail.filter.extraField2key;
      this.selectedMail.filter.extraField2value = mail.filter.extraField2value;
      this.selectedMail.filter.extraField3key = mail.filter.extraField3key;
      this.selectedMail.filter.extraField3value = mail.filter.extraField3value;
      this.selectedMail.filter.extraField4key = mail.filter.extraField4key;
      this.selectedMail.filter.extraField4value = mail.filter.extraField4value;
      this.selectedMail.filter.isVisitor = mail.filter.isVisitor;
      this.selectedMail.filter.plateNo = mail.filter.plateNo;
      this.selectedMail.authorizedUsers = mail.authorizedUsers;
      this.getFilter(mail.filter);
      this.days.forEach(doc => {
        doc.check = false;
      });
      this.days.forEach(doc => {
        this.selectedMail.days.forEach(doc2 => {
          if (doc.value == doc2) {
            doc.check = true;
          }
        });
      });
      this.reports.forEach(doc => {
        doc.checked = false;
      });
      this.reports.forEach(doc => {
        this.selectedMail.reports.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.checked = true;
          }
        });
      });
    },
    async getMails() {
      try {
        this.isLoading = true;
        this.mails = [];
        const response = await this.$axios
          .get("/Mail")
          .then(response => {
            this.mails = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getAllEmployees() {
      try {
        const allEmployees = [];
        const response = await this.$axios
          .get("/Employees")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                if (doc.isVisitor == false) {
                  allEmployees.push({
                    id: doc.id,
                    name: doc.name,
                    title: doc.title,
                    isVisitor: doc.isVisitor,
                    isCheck: false
                  });
                }
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.allEmployees = allEmployees;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getConfig();
    await this.getMails();

    await this.getDepartments();
    await this.getFoodGroups();
    await this.getExtraFields();
    await this.getAccessGroups();
    await this.getStatus();
    await this.getStates();
    await this.getWorkGroups();
    await this.getTitles();
    await this.getAllEmployees();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mailSmsSettings/MailSmsSettings.vue